import $ from 'jquery';

// TODO: switch to https://www.npmjs.com/package/modernizr-loader
const { Modernizr } = window;

/**
 * input placeholder functionality for older browsers
 */
$.fn.extend({
    placeholder: function () {
        return this.each((index, element) => {
            const input = $(element);

            if (input.attr('placeholder') !== '' && !Modernizr.placeholder) {
                //placeholder
                input
                    .focus(() => {
                        if (input.val() === input.attr('placeholder')) {
                            input.val('');
                            input.removeClass('placeholder');
                        }
                    })
                    .blur(() => {
                        if (input.val() === '' || input.val() === input.attr('placeholder')) {
                            input.addClass('placeholder');
                            input.val(input.attr('placeholder'));
                        }
                    })
                    .blur();

                input
                    .parents('form')
                    .submit((event) => {
                        $(event.target)
                            .find('[placeholder]')
                            .each(() => {
                                if (input.val() === input.attr('placeholder')) {
                                    input.val('');
                                }
                            });
                    });
            }

            input
                .bind('blur keyup', () => {
                    //empty
                    const query = $.trim(input.val());
                    if (query === '' || query === input.attr('placeholder')) {
                        input.addClass('empty');
                    } else {
                        input.removeClass('empty');
                    }
                })
                .trigger('blur');
        });
    }
});


// WEBPACK FOOTER //
// ./jquery/jquery.placeholder.js